<template>
  <v-card
    text
    flat
  >
    <v-data-table
      :headers="headers"
      :items="payments"
      :loading="loading"
      :items-per-page-options="rowsPerPageItems"
      :items-per-page-text="rowsPerPageText"
      :custom-sort="filteredPayments"
      :hide-default-footer="payments.length < 11"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <ReferenceTitle
              :id="item.id"
              component-name="Payment"
              :title="item.id"
              class="primary--text"
            />
          </td>
          <td>
            {{ item.date | date }}
          </td>
          <td>
            <PaymentTypeLabel :value="item.paymentType" />
          </td>
          <td>
            {{ item.project ? item.project.title : "" }}
          </td>
          <td>
            {{ item.hours }}
          </td>
          <td>
            {{ item.amount }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import * as clientsApi from "../../../backend/clientsApi.js";
import PaymentTypeLabel from "../../../components/enums/PaymentTypeLabel.vue";

export default {
  components: {
    ReferenceTitle() {
      return import("../../../components/ReferenceTitle.vue");
    },
    PaymentTypeLabel,
  },
  props: ["id"],
  data: () => ({
    headers: [
      { text: "id", sortable: false },
      { text: "Дата", sortable: false },
      { text: "Тип", sortable: false },
      { text: "Проект", sortable: false },
      { text: "Години", sortable: false },
      { text: "Сума", sortable: false },
    ],
    payments: [],
    loading: false,
    rowsPerPageItems: [5, 10, 25, { text: "Всі", value: -1 }],
    rowsPerPageText: "Рядків на сторінці:",
  }),
  created() {
    this.loading = true;
    this.getPayments();
    this.loading = false;
  },
  methods: {
    async getPayments() {
      this.payments = await clientsApi.getPayments(this.id);
    },
    filteredPayments() {
      return this.payments.sort((a, b) => {
        const dateA = a.date;
        const dateB = b.date;

        if (dateA < dateB) {
          return 1;
        }
        if (dateA > dateB) {
          return -1;
        }
        return 0;
      });
    },
  },
};
</script>
